import { CartItem, CartItemPrice } from "@client/content/modules/Cart/Items/component";
import classNames from "classnames";
import React from "react";
import { type Checkout } from "../types";
import { CART_IMAGE_SIZE } from "./lib";

type Props = {
  isActive?: boolean;
  isNameHidden?: boolean;
  currencyCode: string;
  isMobile: boolean;
  item: Checkout.Api.CartItem;
  prepend?: any;
  onClick?: () => void;
  noImageUrl: string;
  style?: React.CSSProperties;
};
export default (props: Props) => (
  <div
    style={props.style}
    className={classNames("item", { pointer: props.onClick, active: props.isActive })}
    onClick={props.onClick}
  >
    {props.prepend}

    <CartItem
      imageSize={CART_IMAGE_SIZE}
      isNameHidden={props.isNameHidden}
      noImageUrl={props.noImageUrl}
      {...props.item}
      permalink={null}
      addon={
        props.isMobile ? (
          <CartItemPrice item={props.item} currencyCode={props.currencyCode} shouldDisplayTax={false} />
        ) : null
      }
    />
    {props.isMobile ? null : (
      <CartItemPrice item={props.item} currencyCode={props.currencyCode} shouldDisplayTax={false} />
    )}
  </div>
);
